export const STARTER_PLAN_NAME = 'Starter';

export const PREMIUM_PLAN_NAME = 'Premium';

export const SUBSCRIPTION_STATUS = {
    ACTIVE: 'active',
    CANCELED: 'canceled',
    INCOMPLETE: 'incomplete',
    INCOMPLETE_EXPIRED: 'incomplete_expired',
    PAST_DUE: 'past_due',
    PAUSED: 'paused',
    TRIALING: 'trialing',
    UNPAID: 'unpaid',
};
